var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('quill-editor-local',{ref:"myQuillEditor",staticClass:"canvas",attrs:{"options":{
      theme: 'snow',
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          ['blockquote'],
          [{ header: 3 }, { header: 4 }],
          [{ indent: '-1' }, { indent: '+1' }],
          [{ header: [1, 2, 3, 4, false] }],
          [{ align: [] }],
          ['clean'],
          ['link', 'details'],
        ],
        resize: {
          locale: {},
        },
      },
    },"create-image":_setup.dummy},on:{"change":function($event){return _setup.onEditorChange($event)}},model:{value:(_setup.content),callback:function ($$v) {_setup.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }